import React, { useState } from 'react';
import LazyImage from '../LazyImage';
import './HomeContact.css';
import girlImage from '../../assets/images/girl.webp';
import girl1Image from '../../assets/images/girl1.webp';
import planeIcon from '../../assets/icons/plane.png';
import axios from 'axios';
import { ADMIN_EMAIL, EMAIL } from '../../Utils/EmailHelper';

const HomeContact = () => {
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phoneNumber: '',
        service: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        let dataAdmin = {
            "sender_email": EMAIL,
            "receiver_email": EMAIL,
            "subject": "New Service Request",
            "domain": "pfgs",
            "html_body": ADMIN_EMAIL(formData)
        }
        try {
            const responseAdmin = await axios.post('https://m52vkpoo46edzgvw3bkscwsfgq0xrxsm.lambda-url.us-east-1.on.aws', dataAdmin);
            if (responseAdmin.data.message === 'Email sent successfully.') {
                setResponseMessage(responseAdmin.data.message);
                setTimeout(() => {
                    setResponseMessage('');
                }, 5000);

            }
            setLoading(false)
        } catch (error) {
            setResponseMessage(
                error.response?.data?.message || 'Something went wrong. Please try again.'
            );
            setTimeout(() => {
                setResponseMessage('');
            }, 5000);
            setLoading(false)
        }

    };

    const contactIntro = (
        <>
            <h2 className="home-contact-title">
                Ready to Take the <span className="text-primary">Stress</span>{' '}
                <br className="desktop-break" />
                <span className="text-primary">Out of Tax Time?</span>
            </h2>
            <p className="home-contact-description">
                Let our experts handle the numbers — so you can focus on what
                matters most. Whether you're an individual, a freelancer, or a
                business owner, we're here to help.
            </p>
        </>
    );

    return (
        <section className="home-contact">
            <div className="container">
                <div className="home-contact-content">
                    <div className="home-contact-left">
                        <div className="home-contact-text home-contact-text-desktop">{contactIntro}</div>
                        <div className="home-contact-image">
                            <picture>
                                <source media="(max-width: 767px)" srcSet={girl1Image} />
                                <LazyImage src={girlImage} alt="Professional woman" />
                            </picture>
                        </div>
                    </div>

                    <div className="home-contact-right">
                        <div className="home-contact-text home-contact-text-mobile">{contactIntro}</div>
                        <div className="contact-card">
                            <div className="card-header">
                                <h3 className="card-title">Let's Take the Stress Out of Your Taxes</h3>
                                <p className="card-description">
                                    Fill out the form and our team will get back to you shortly.
                                </p>
                            </div>

                            <form className="contact-form" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="fullName" className="form-label">Full Name</label>
                                    <input
                                        type="text"
                                        id="fullName"
                                        name="fullName"
                                        className="form-input"
                                        placeholder="Enter your full name"
                                        value={formData.fullName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            className="form-input"
                                            placeholder="Enter your email address"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="phoneNumber" className="form-label">Phone Number</label>
                                        <input
                                            type="tel"
                                            id="phoneNumber"
                                            name="phoneNumber"
                                            className="form-input"
                                            placeholder="Enter your phone number"
                                            value={formData.phoneNumber}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="service" className="form-label">Service</label>
                                    <select
                                        id="service"
                                        name="service"
                                        className="form-input form-select"
                                        value={formData.service}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select</option>
                                        <option value="Individual Tax Preparation">Individual Tax Preparation</option>
                                        <option value="Business Tax Services">Business Tax Services</option>
                                        <option value="Tax Planning">Tax Planning</option>
                                        <option value="Book keeping Services">Book keeping Services</option>
                                        <option value="Audit Support">Audit Support</option>
                                        <option value="Tax Consultation">Tax Consultation</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="message" className="form-label">Message</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        className="form-input form-textarea"
                                        placeholder="Enter your message here"
                                        rows="4"
                                        value={formData.message}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>


                                {loading ? <span>Please wait....</span> : <button type="submit" className="submit-btn">
                                    <span>Send</span>
                                    <img src={planeIcon} alt="" className="btn-icon" />
                                </button>}

                                {responseMessage && <div className="response-message">{responseMessage}</div>}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeContact;